/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_301Inputs */

const cs_ares_legal_form_301 = /** @type {(inputs: Ares_Legal_Form_301Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Státní podnik`)
};

const en_ares_legal_form_301 = /** @type {(inputs: Ares_Legal_Form_301Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State enterprise`)
};

/**
* | output |
* | --- |
* | "State enterprise" |
*
* @param {Ares_Legal_Form_301Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_301 = /** @type {((inputs?: Ares_Legal_Form_301Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_301Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_301(inputs)
	return cs_ares_legal_form_301(inputs)
});